import { RequestService } from '../../../common/services/RequestService';
import { SET_VIEW_LOG } from '../constants';

export const setViewLogRequest = async (profileId, payload, entity = null) => {
  if (entity) {
    payload = { entity: entity, entity_id: payload };
  }
  const response = await RequestService.post(SET_VIEW_LOG + profileId, payload);
  return response;
};
